<template>
  <div class="oi-donate-checkout"></div>
</template>

<script>
import { mapState } from 'vuex'
import externalApi from '@/api/external'

export default {
  computed: mapState({
    message: state => state.checkoutMsg,
    checkoutUrl: state => state.checkoutUrl + '?' + Object.keys(state.checkoutParams).reduce((queryString, param) => {
      return (queryString.length > 0 ? queryString + '&' : '') + encodeURIComponent(param) + '=' + encodeURIComponent(state.checkoutParams[param])
    }, ''),
    checkoutParams: state => state.checkoutParams,
    checkoutType: state => state.checkoutType,
    donation: state => state.donation
  }),
  methods: {
    resetForm () {
      this.$store.dispatch('showStep', 'form')
    },
    showSuccessPage () {
      this.$store.dispatch('showStep', 'thanks')
    },
    showErrorPage () {
      this.$store.dispatch('showStep', 'error')
    }
  },
  mounted () {
    if (this.checkoutType === 'redirect') {
      window.location.href = this.checkoutUrl
    } else if (this.checkoutType === 'popup') {
      const cp = window.cp
      const widget = new cp.CloudPayments()
      widget.outsideClickListener = function (e) {
        if (!document.getElementById('buttonsContainer').contains(e.target)) {
          this.resetForm()
          widget.hideWindow()
        }
      }.bind(this)
      const params = Object.assign({}, this.checkoutParams, { skin: 'mini' })
      widget.charge(params,
        function (options) {
          externalApi.registerDonationInGTM(Object.assign({}, this.donation, { donation_id: params.invoiceId, state: 'success' }))
          this.showSuccessPage()
        }.bind(this),
        function (reason, options) {
          if (reason !== 'User has cancelled') {
            this.showErrorPage()
          } else {
            this.resetForm()
          }
        }.bind(this)
      )
    } else if (this.checkoutType === 'iframe') {
      console.log('IFRAME checkout is not yet implemented')
    }
  }
}
</script>

<style scoped>
  .oi-donate #redirect .title,
  .oi-donate #redirect .message {
    width: 100%;
  }
</style>
